export default {
    products: null,
    metadata: null,
    purchasesModel: false,
    rcConfig: false,
    recentPurchase: false,
    openPurchasesFromMenu: false
}